export const generateLinkToProductPage = (lang, rest) => {
	return `https://${lang}.synthiaiapp.com/${rest}`;
};
